import { FunctionComponent, useState } from "react"
import { Button, Table } from "react-bootstrap"
import { sortArray } from "../utils/ArrayUtils"
import KeycardModal from "./KeycardModal"

interface IKeycardsSubForm {
	keycards: string[]
	setKeycards: (value: string[]) => any
}
const KeycardsSubForm: FunctionComponent<IKeycardsSubForm> = ({ keycards, setKeycards }) => {
	// this is which row is open in the modal; undefined means the modal is closed
	const [modalIndex, setModalIndex] = useState<number | null>(null)
	// sorting will call setValue with the items in a new order
	const sortBy = (sortProperty: string) => setKeycards(sortArray(keycards, sortProperty, "AUTO"))
	//
	return (
		<>
			<KeycardModal
				onHide={() => setModalIndex(null)}
				keycards={keycards}
				setKeycards={setKeycards}
				index={modalIndex}
			/>
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("")}>Keycard</th>
					</tr>
				</thead>
				<tbody>
					{keycards?.map((keycard, i) => (
						<tr key={keycard} onClick={() => setModalIndex(i)}>
							<td>{keycard}</td>
						</tr>
					))}
					<tr>
						<td colSpan={10} className="text-center">
							<Button variant="outline-success" size="sm" onClick={() => setModalIndex(keycards?.length || 0)}>
								Add Keycard
							</Button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	)
}
export default KeycardsSubForm
